import { useParams } from 'react-router-dom';
import { CampaignCreatorType } from '@/services/dictionaries/Paths';

export const useIsTypeAB = (): boolean => {
    const { type } = useParams<{ name: string; type: string }>();
    return type === CampaignCreatorType.AB;
};
